var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYmcaTcaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 304,
    height: 96,
    viewBox: "0 0 304 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.837 41.745C110.614 41.892 111.734 41.892 112.623 41.892C113.96 41.892 115.297 41.703 116.634 41.703C118.307 41.703 118.489 42.592 118.489 43.67V45.042C118.489 46.456 117.299 46.603 116.151 46.715C114.737 46.827 113.288 46.897 111.881 46.897C102.851 46.897 100.695 42.662 100.695 34.297C100.695 29.915 101.101 24.154 105.784 22.222C107.639 21.48 109.872 21.333 111.881 21.333C113.295 21.333 114.744 21.41 116.151 21.522C117.306 21.634 118.489 21.781 118.489 23.195V24.385C118.489 25.869 118.23 26.541 116.634 26.541C115.297 26.541 113.96 26.359 112.623 26.359C111.622 26.359 109.613 26.359 108.724 26.807C106.827 27.738 106.68 29.705 106.68 34.311V35.088C106.68 39.736 107.499 41.297 109.837 41.738V41.745Z",
    fill: "url(#paint0_radial_878_36086)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132.732 47.2049C124.374 47.2049 121.693 41.5559 121.693 34.0519C121.693 26.5479 124.332 20.8989 132.732 20.8989C141.132 20.8989 143.806 26.5129 143.806 34.0519C143.806 41.5909 141.09 47.2049 132.732 47.2049ZM137.002 27.9899C136.183 26.3169 134.44 25.9459 132.732 25.9459C131.024 25.9459 129.316 26.3169 128.497 27.9899C127.79 29.4389 127.72 32.4139 127.72 34.0449C127.72 35.6759 127.797 38.6159 128.497 40.0649C129.316 41.7379 131.024 42.1439 132.732 42.1439C134.44 42.1439 136.19 41.7379 137.002 40.0649C137.709 38.6159 137.779 35.6829 137.779 34.0449C137.779 32.4069 137.702 29.4389 137.002 27.9899Z",
    fill: "url(#paint1_radial_878_36086)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M168.293 44.9436C168.293 45.9866 167.474 46.4276 166.543 46.4276H164.499C163.344 46.4276 162.749 45.9446 162.343 44.9016L161.188 41.8566C159.704 41.8916 158.213 41.8916 156.729 41.8916C155.245 41.8916 153.754 41.8916 152.27 41.8566L151.269 44.6426C150.821 45.8676 150.338 46.4276 148.966 46.4276H147.258C146.215 46.4276 145.361 46.3156 145.361 45.1256C145.361 44.8316 145.585 44.1946 145.697 43.9006L153.355 23.3487C153.985 21.6407 154.804 21.4517 156.141 21.4517H157.478C158.927 21.4517 159.557 21.9697 160.082 23.3067L168.146 44.2296C168.223 44.4536 168.293 44.6776 168.293 44.9366V44.9436ZM153.838 37.4746H159.557L156.694 29.2217L153.831 37.4746H153.838Z",
    fill: "url(#paint2_radial_878_36086)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M179.105 41.745C179.882 41.892 181.002 41.892 181.891 41.892C183.228 41.892 184.565 41.703 185.902 41.703C187.575 41.703 187.757 42.592 187.757 43.67V45.042C187.757 46.456 186.567 46.603 185.419 46.715C184.005 46.827 182.556 46.897 181.149 46.897C172.119 46.897 169.963 42.662 169.963 34.297C169.963 29.915 170.369 24.154 175.052 22.222C176.907 21.48 179.14 21.333 181.149 21.333C182.563 21.333 184.012 21.41 185.419 21.522C186.574 21.634 187.757 21.781 187.757 23.195V24.385C187.757 25.869 187.498 26.541 185.902 26.541C184.565 26.541 183.228 26.359 181.891 26.359C180.89 26.359 178.881 26.359 177.992 26.807C176.095 27.738 175.948 29.705 175.948 34.311V35.088C175.948 39.736 176.767 41.297 179.105 41.738V41.745Z",
    fill: "url(#paint3_radial_878_36086)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M209.655 46.4279H208.577C207.163 46.4279 206.344 45.9449 206.344 44.4189V35.5359C205.007 35.5709 203.628 35.5709 202.256 35.5709C200.884 35.5709 199.54 35.5709 198.168 35.5359V44.4189C198.168 46.2039 197.055 46.4279 195.753 46.4279H194.563C193.149 46.4279 192.33 45.9449 192.33 44.4189V23.503C192.33 21.83 193.52 21.606 194.78 21.606H196.152C197.412 21.606 198.161 22.201 198.161 23.503V30.8599C199.533 30.8249 200.877 30.7829 202.249 30.7829C203.621 30.7829 205 30.8179 206.337 30.8599V23.503C206.337 21.795 207.604 21.606 208.899 21.606H210.124C211.384 21.606 212.168 22.201 212.168 23.503V44.4259C212.168 46.2459 210.978 46.4349 209.641 46.4349L209.655 46.4279Z",
    fill: "url(#paint4_radial_878_36086)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M123.385 78.4322C123.385 79.5522 122.51 80.0282 121.509 80.0282H119.311C118.072 80.0282 117.435 79.5102 116.994 78.3902L115.755 75.1212C114.159 75.1632 112.563 75.1632 110.967 75.1632C109.371 75.1632 107.775 75.1632 106.179 75.1212L105.101 78.1172C104.625 79.4332 104.1 80.0352 102.63 80.0352H100.803C99.6826 80.0352 98.7656 79.9162 98.7656 78.6352C98.7656 78.3132 99.0036 77.6342 99.1226 77.3192L107.341 55.2553C108.02 53.4213 108.895 53.2183 110.337 53.2183H111.772C113.326 53.2183 114.005 53.7783 114.565 55.2133L123.224 77.6832C123.301 77.9212 123.385 78.1592 123.385 78.4392V78.4322ZM107.859 70.4102H114.005L110.932 61.5483L107.859 70.4102Z",
    fill: "url(#paint5_radial_878_36086)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M126.254 77.872V55.4091C126.254 53.8131 127.248 53.3721 128.648 53.3721H137.027C139.897 53.3721 141.619 53.6941 143.25 55.3251C145.126 57.2011 145.448 60.3511 145.448 62.8641C145.448 66.0141 144.853 69.3321 141.738 70.8441C140.422 71.4811 138.623 71.7611 135.914 71.7611C135.158 71.7611 133.359 71.7611 132.519 71.7191V77.865C132.519 79.384 131.721 80.021 130.321 80.021H128.648C127.129 80.021 126.254 79.503 126.254 77.865V77.872ZM136.831 66.4201C137.433 66.4201 138.427 66.3781 138.826 65.8601C139.225 65.3421 139.225 63.7041 139.225 63.0251C139.225 60.7921 139.106 59.2731 138.385 58.9161C137.909 58.6781 136.509 58.6781 135.914 58.6781C134.794 58.6781 133.639 58.6781 132.519 58.7201V66.4201H136.831Z",
    fill: "url(#paint6_radial_878_36086)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M150.16 77.872V55.4091C150.16 53.8131 151.161 53.3721 152.554 53.3721H160.933C163.803 53.3721 165.525 53.6941 167.156 55.3251C169.032 57.2011 169.354 60.3511 169.354 62.8641C169.354 66.0141 168.752 69.3321 165.644 70.8441C164.328 71.4811 162.529 71.7611 159.82 71.7611C159.064 71.7611 157.265 71.7611 156.425 71.7191V77.865C156.425 79.384 155.627 80.021 154.227 80.021H152.554C151.035 80.021 150.16 79.503 150.16 77.865V77.872ZM160.737 66.4201C161.332 66.4201 162.333 66.3781 162.732 65.8601C163.131 65.3421 163.131 63.7041 163.131 63.0251C163.131 60.7921 163.012 59.2731 162.291 58.9161C161.815 58.6781 160.415 58.6781 159.82 58.6781C158.7 58.6781 157.545 58.6781 156.425 58.7201V66.4201H160.737Z",
    fill: "url(#paint7_radial_878_36086)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M176.453 53.3721H184.552C187.268 53.3721 189.221 53.4911 191.055 55.3251C192.931 57.2011 193.253 60.3511 193.253 62.8641C193.253 66.3781 192.098 69.4511 188.346 70.3681L193.974 76.913C194.373 77.354 194.611 77.9911 194.611 78.5511C194.611 79.671 193.736 80.028 192.777 80.028H190.383C189.144 80.028 188.346 79.79 187.548 78.789L180.884 70.6481H180.324V77.872C180.324 79.272 179.568 80.028 178.168 80.028H176.453C174.934 80.028 174.059 79.51 174.059 77.872V55.4091C174.059 53.8131 175.06 53.3721 176.453 53.3721ZM187.03 62.5491C187.03 61.1491 186.911 59.2381 186.19 58.9161C185.749 58.7131 184.671 58.6781 183.719 58.6781H182.599C181.843 58.6781 181.08 58.6781 180.324 58.7201V65.3421H184.391C186.785 65.3421 187.023 64.8661 187.023 62.5491H187.03Z",
    fill: "url(#paint8_radial_878_36086)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M209.611 80.8677C200.63 80.8677 197.76 74.7987 197.76 66.7417C197.76 58.6847 200.595 52.6157 209.611 52.6157C218.627 52.6157 221.504 58.6427 221.504 66.7417C221.504 74.8407 218.592 80.8677 209.611 80.8677ZM214.203 60.2387C213.328 58.4397 211.452 58.0407 209.611 58.0407C207.77 58.0407 205.943 58.4397 205.061 60.2387C204.305 61.7927 204.221 64.9847 204.221 66.7417C204.221 68.4987 204.298 71.6487 205.061 73.2097C205.936 75.0017 207.777 75.4427 209.611 75.4427C211.445 75.4427 213.321 75.0017 214.203 73.2097C214.959 71.6557 215.043 68.4987 215.043 66.7417C215.043 64.9847 214.966 61.7927 214.203 60.2387Z",
    fill: "url(#paint9_radial_878_36086)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M247.797 78.4322C247.797 79.5522 246.922 80.0282 245.921 80.0282H243.723C242.484 80.0282 241.847 79.5102 241.406 78.3902L240.167 75.1212C238.571 75.1632 236.975 75.1632 235.379 75.1632C233.783 75.1632 232.187 75.1632 230.591 75.1212L229.513 78.1172C229.037 79.4332 228.512 80.0352 227.035 80.0352H225.201C224.081 80.0352 223.164 79.9162 223.164 78.6352C223.164 78.3132 223.402 77.6342 223.521 77.3192L231.739 55.2553C232.418 53.4213 233.293 53.2183 234.735 53.2183H236.17C237.724 53.2183 238.403 53.7783 238.963 55.2133L247.622 77.6832C247.699 77.9212 247.783 78.1592 247.783 78.4392L247.797 78.4322ZM232.278 70.4102H238.424L235.351 61.5483L232.278 70.4102Z",
    fill: "url(#paint10_radial_878_36086)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M259.4 75.0023C260.24 75.1633 261.437 75.1633 262.396 75.1633C263.831 75.1633 265.266 74.9603 266.708 74.9603C268.507 74.9603 268.703 75.9193 268.703 77.0743V78.5513C268.703 80.0703 267.429 80.2243 266.19 80.3503C264.671 80.4693 263.117 80.5533 261.598 80.5533C251.903 80.5533 249.586 76.0033 249.586 67.0223C249.586 62.3113 250.027 56.1303 255.053 54.0513C257.048 53.2533 259.442 53.0923 261.598 53.0923C263.117 53.0923 264.671 53.1693 266.19 53.2883C267.429 53.4073 268.703 53.5683 268.703 55.0873V56.3613C268.703 57.9573 268.423 58.6783 266.708 58.6783C265.273 58.6783 263.838 58.4753 262.396 58.4753C261.318 58.4753 259.162 58.4753 258.203 58.9513C256.166 59.9453 256.005 62.0663 256.005 67.0083V67.8483C256.005 72.8393 256.88 74.5123 259.4 74.9883V75.0023Z",
    fill: "url(#paint11_radial_878_36086)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M292.203 80.028H291.048C289.529 80.028 288.654 79.51 288.654 77.872V68.3381C287.219 68.3801 285.742 68.3801 284.265 68.3801C282.788 68.3801 281.353 68.3801 279.876 68.3381V77.872C279.876 79.79 278.679 80.028 277.279 80.028H276.005C274.486 80.028 273.611 79.51 273.611 77.872V55.4091C273.611 53.6101 274.885 53.3721 276.243 53.3721H277.72C279.078 53.3721 279.876 54.0091 279.876 55.4091V63.3121C281.353 63.2701 282.788 63.2351 284.265 63.2351C285.742 63.2351 287.219 63.2771 288.654 63.3121V55.4091C288.654 53.5751 290.012 53.3721 291.405 53.3721H292.721C294.079 53.3721 294.919 54.0091 294.919 55.4091V77.872C294.919 79.825 293.645 80.028 292.203 80.028Z",
    fill: "url(#paint12_radial_878_36086)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M300.805 55.1431C302.751 55.1431 303.479 56.2561 303.479 58.1321C303.479 60.2251 302.631 61.1841 300.798 61.1841C299.09 61.1841 298.229 60.1971 298.229 58.1671C298.229 56.1371 299.083 55.1501 300.805 55.1501V55.1431ZM300.881 60.6521C302.4 60.6521 302.758 59.5881 302.758 58.2021C302.744 56.9001 302.457 55.6961 300.868 55.6961C299.279 55.6961 298.943 56.6901 298.943 58.1741C298.943 59.5111 299.264 60.6521 300.881 60.6521ZM300.021 56.6971H301.077C301.679 56.6971 301.96 56.9281 301.96 57.7401C301.96 58.2511 301.686 58.5171 301.315 58.5801L302.064 59.4901C302.113 59.5531 302.121 59.5811 302.121 59.6161C302.121 59.6721 302.086 59.7071 302.002 59.7071H301.644C301.539 59.7071 301.47 59.6931 301.393 59.5951L300.615 58.6011H300.455V59.5391C300.455 59.6581 300.406 59.7001 300.301 59.7001H300.021C299.888 59.7001 299.839 59.6721 299.839 59.5391V56.8441C299.839 56.7041 299.93 56.6971 300.021 56.6971ZM301.364 57.6981C301.364 57.2361 301.288 57.1871 300.819 57.1871C300.672 57.1871 300.525 57.1871 300.455 57.1871V58.0971H300.98C301.267 58.0971 301.364 58.0201 301.364 57.6911V57.6981Z",
    fill: "#00AB8E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M257.618 46.4836C264.519 46.4836 270.113 40.8894 270.113 33.9886C270.113 27.0878 264.519 21.4937 257.618 21.4937C250.717 21.4937 245.123 27.0878 245.123 33.9886C245.123 40.8894 250.717 46.4836 257.618 46.4836Z",
    fill: "url(#paint13_radial_878_36086)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M253.431 29.0127H253.186C252.703 29.0127 252.311 29.4047 252.311 29.8877V30.9727C252.199 30.9237 252.08 30.8957 251.954 30.8957H251.73C251.247 30.8957 250.855 31.2877 250.855 31.7707V36.2647C250.855 36.7477 251.247 37.1397 251.73 37.1397H251.954C252.08 37.1397 252.199 37.1117 252.311 37.0627V38.1477C252.311 38.6307 252.703 39.0227 253.186 39.0227H253.431C253.914 39.0227 254.306 38.6307 254.306 38.1477V29.8877C254.306 29.4047 253.914 29.0127 253.431 29.0127Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M263.056 30.8957H262.832C262.706 30.8957 262.587 30.9237 262.475 30.9727V29.8877C262.475 29.4047 262.083 29.0127 261.6 29.0127H261.355C260.872 29.0127 260.48 29.4047 260.48 29.8877V38.1477C260.48 38.6307 260.872 39.0227 261.355 39.0227H261.6C262.083 39.0227 262.475 38.6307 262.475 38.1477V37.0627C262.587 37.1117 262.706 37.1397 262.832 37.1397H263.056C263.539 37.1397 263.931 36.7477 263.931 36.2647V31.7707C263.931 31.2877 263.539 30.8957 263.056 30.8957Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M259.753 33.2339H255.042C254.96 33.2339 254.895 33.2997 254.895 33.3809V34.6549C254.895 34.7361 254.96 34.8019 255.042 34.8019H259.753C259.834 34.8019 259.9 34.7361 259.9 34.6549V33.3809C259.9 33.2997 259.834 33.2339 259.753 33.2339Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M250.122 33.2339H249.821C249.646 33.2339 249.506 33.3669 249.506 33.5279V34.5149C249.506 34.6759 249.646 34.8089 249.821 34.8089H250.122C250.206 34.8089 250.269 34.7459 250.269 34.6619V33.3879C250.269 33.3039 250.206 33.2409 250.122 33.2409V33.2339Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M265.328 33.5279C265.328 33.3669 265.188 33.2339 265.013 33.2339H264.663C264.579 33.2339 264.516 33.2969 264.516 33.3809V34.6549C264.516 34.7389 264.579 34.8019 264.663 34.8019H265.013C265.188 34.8019 265.328 34.6689 265.328 34.5079V33.5209V33.5279Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M285.28 46.4836C292.181 46.4836 297.775 40.8894 297.775 33.9886C297.775 27.0878 292.181 21.4937 285.28 21.4937C278.379 21.4937 272.785 27.0878 272.785 33.9886C272.785 40.8894 278.379 46.4836 285.28 46.4836Z",
    fill: "url(#paint14_radial_878_36086)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M285.359 30.1521L284.372 29.1581C284.323 29.1091 284.239 29.1021 284.183 29.1581L284.113 29.2211C284.057 29.2701 284.057 29.3541 284.106 29.4101L285.03 30.4741C285.03 30.4741 285.009 30.5371 284.995 30.5651C284.96 30.7051 284.981 30.8591 285.065 30.9921C285.226 31.2581 285.576 31.3491 285.842 31.1811C285.975 31.0971 286.066 30.9711 286.101 30.8311C286.136 30.6911 286.115 30.5371 286.038 30.4041C285.898 30.1731 285.611 30.0751 285.366 30.1591L285.359 30.1521Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M290.868 29.718H288.355C288.285 29.522 288.201 29.326 288.089 29.144C287.235 27.737 285.408 27.289 284.001 28.143C283.385 28.521 282.951 29.088 282.734 29.718H280.221C279.738 29.718 279.374 30.11 279.409 30.593L280.067 39.448C280.102 39.931 280.529 40.323 281.012 40.323H284.967C285.051 40.323 285.114 40.26 285.114 40.176V34.373C285.114 34.212 285.247 34.079 285.408 34.079H285.702C285.863 34.079 285.996 34.212 285.996 34.373V40.176C285.996 40.26 286.059 40.323 286.143 40.323H290.098C290.581 40.323 291.001 39.931 291.043 39.448L291.701 30.593C291.736 30.11 291.372 29.718 290.889 29.718H290.868ZM287.795 31.237C287.648 31.839 287.277 32.35 286.745 32.672C285.653 33.337 284.218 32.987 283.553 31.888C283.231 31.356 283.133 30.733 283.28 30.131C283.427 29.529 283.798 29.018 284.33 28.696C285.422 28.031 286.857 28.381 287.522 29.48C287.844 30.012 287.942 30.635 287.795 31.237Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M229.944 46.4836C236.845 46.4836 242.439 40.8894 242.439 33.9886C242.439 27.0878 236.845 21.4937 229.944 21.4937C223.043 21.4937 217.449 27.0878 217.449 33.9886C217.449 40.8894 223.043 46.4836 229.944 46.4836Z",
    fill: "url(#paint15_radial_878_36086)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M230.502 36.5649H228.885C228.731 36.5649 228.598 36.6909 228.598 36.8519V37.0969C228.598 37.2509 228.724 37.3839 228.885 37.3839H230.726C230.803 37.3839 230.831 37.3349 230.789 37.2649C230.691 37.0969 230.635 36.9079 230.635 36.7049C230.635 36.6839 230.635 36.6629 230.635 36.6349C230.635 36.5999 230.579 36.5649 230.495 36.5649H230.502Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M231.433 31.7549H228.892C228.734 31.7549 228.605 31.8834 228.605 32.0419V32.2799C228.605 32.4384 228.734 32.5669 228.892 32.5669H231.433C231.592 32.5669 231.72 32.4384 231.72 32.2799V32.0419C231.72 31.8834 231.592 31.7549 231.433 31.7549Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M231.433 34.1636H228.892C228.734 34.1636 228.605 34.2921 228.605 34.4506V34.6886C228.605 34.8471 228.734 34.9756 228.892 34.9756H231.433C231.592 34.9756 231.72 34.8471 231.72 34.6886V34.4506C231.72 34.2921 231.592 34.1636 231.433 34.1636Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M227.703 31.7549H227.486C227.328 31.7549 227.199 31.8834 227.199 32.0419V32.2799C227.199 32.4384 227.328 32.5669 227.486 32.5669H227.703C227.862 32.5669 227.99 32.4384 227.99 32.2799V32.0419C227.99 31.8834 227.862 31.7549 227.703 31.7549Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M227.703 34.1636H227.486C227.328 34.1636 227.199 34.2921 227.199 34.4506V34.6886C227.199 34.8471 227.328 34.9756 227.486 34.9756H227.703C227.862 34.9756 227.99 34.8471 227.99 34.6886V34.4506C227.99 34.2921 227.862 34.1636 227.703 34.1636Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M227.703 36.5649H227.486C227.328 36.5649 227.199 36.6934 227.199 36.8519V37.0899C227.199 37.2484 227.328 37.3769 227.486 37.3769H227.703C227.862 37.3769 227.99 37.2484 227.99 37.0899V36.8519C227.99 36.6934 227.862 36.5649 227.703 36.5649Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M230.753 26.3583C230.753 26.2043 230.627 26.0713 230.466 26.0713H228.471C228.317 26.0713 228.184 26.1973 228.184 26.3583V27.1983H230.753V26.3583Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M238.029 34.9056L237.35 34.2266C237.294 34.1706 237.224 34.1426 237.147 34.1426C237.077 34.1426 237 34.1706 236.944 34.2266L234.025 37.1456L233.353 36.4876L232.653 35.8016C232.653 35.8016 232.625 35.7736 232.611 35.7666C232.611 35.7666 232.597 35.7666 232.59 35.7596C232.583 35.7596 232.569 35.7456 232.562 35.7456C232.555 35.7456 232.541 35.7456 232.534 35.7386C232.527 35.7386 232.52 35.7386 232.513 35.7386C232.506 35.7386 232.492 35.7386 232.485 35.7386C232.478 35.7386 232.471 35.7386 232.464 35.7386C232.45 35.7386 232.443 35.7386 232.429 35.7386C232.429 35.7386 232.415 35.7386 232.408 35.7386C232.394 35.7386 232.387 35.7386 232.373 35.7456C232.373 35.7456 232.359 35.7456 232.352 35.7456C232.345 35.7456 232.331 35.7526 232.324 35.7596C232.324 35.7596 232.31 35.7596 232.303 35.7736C232.296 35.7736 232.289 35.7876 232.282 35.7876C232.275 35.7876 232.268 35.8016 232.261 35.8086L231.589 36.4946C231.491 36.5996 231.484 36.7606 231.568 36.8726C231.575 36.8796 231.582 36.8936 231.589 36.9006L232.163 37.4606L233.836 39.1056C233.892 39.1616 233.962 39.1896 234.039 39.1896C234.109 39.1896 234.186 39.1616 234.242 39.1056L238.036 35.3116C238.148 35.1996 238.148 35.0176 238.036 34.9056H238.029Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M234.936 39.6096L234.838 39.7076C234.621 39.9246 234.334 40.0436 234.033 40.0436C233.753 40.0436 233.494 39.9456 233.284 39.7636C233.284 39.7636 233.27 39.7496 233.263 39.7426L233.242 39.7286H233.235L233.228 39.7146L233.116 39.6026C233.06 39.5466 232.976 39.5466 232.913 39.5816C232.878 39.6026 232.836 39.6096 232.794 39.6096H226.137C225.983 39.6096 225.85 39.4836 225.85 39.3226V29.6976C225.85 29.5436 225.976 29.4106 226.137 29.4106H232.794C232.948 29.4106 233.081 29.5366 233.081 29.6976V34.9056C233.081 34.9826 233.123 35.0736 233.172 35.1156C233.2 35.1366 233.228 35.1646 233.256 35.1926L233.921 35.8436C233.977 35.8996 234.068 35.8996 234.124 35.8436L234.936 35.0316C234.992 34.9756 235.034 34.8636 235.034 34.7866V28.0596C235.034 27.5906 234.649 27.2056 234.18 27.2056H230.743V28.0316C230.743 28.1856 230.617 28.3186 230.456 28.3186H228.461C228.307 28.3186 228.174 28.1926 228.174 28.0316V27.2056H224.737C224.268 27.2056 223.883 27.5906 223.883 28.0596V40.8836C223.883 41.3526 224.268 41.7376 224.737 41.7376H234.173C234.642 41.7376 235.027 41.3526 235.027 40.8836V39.6516C235.027 39.5746 234.985 39.5536 234.929 39.6096H234.936Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3965 21.0449C81.7688 21.0449 82.2821 21.727 82.2821 22.8766C82.2821 24.1593 81.6848 24.747 80.3916 24.747C79.1872 24.747 78.5801 24.1421 78.5801 22.8981C78.5801 21.6541 79.1823 21.0492 80.3965 21.0492V21.0449ZM80.4508 24.4209C81.522 24.4209 81.7737 23.7689 81.7737 22.9195C81.7638 22.1216 81.5614 21.3838 80.441 21.3838C79.3205 21.3838 79.0835 21.993 79.0835 22.9024C79.0835 23.7217 79.3106 24.4209 80.4508 24.4209ZM79.8437 21.9972H80.589C81.0135 21.9972 81.211 22.1388 81.211 22.6364C81.211 22.9496 81.0185 23.1126 80.7569 23.1512L81.285 23.7088C81.3196 23.7475 81.3245 23.7646 81.3245 23.7861C81.3245 23.8204 81.2998 23.8418 81.2406 23.8418H80.9889C80.9148 23.8418 80.8655 23.8332 80.8112 23.7732L80.2633 23.164H80.1497V23.7389C80.1497 23.8118 80.1152 23.8375 80.0411 23.8375H79.8437C79.7499 23.8375 79.7154 23.8204 79.7154 23.7389V22.0873C79.7154 22.0015 79.7795 21.9972 79.8437 21.9972ZM80.7914 22.6107C80.7914 22.3276 80.7371 22.2975 80.4064 22.2975C80.3027 22.2975 80.1991 22.2975 80.1497 22.2975V22.8552H80.5199C80.7223 22.8552 80.7914 22.808 80.7914 22.6064V22.6107Z",
    fill: "#00AB8E"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9752 75.2916L52.7848 78.0071L52.3377 78.7815L49.0781 78.5775L49.5718 77.7224L51.298 77.8873C51.3883 77.8964 51.4809 77.914 51.5758 77.9401C51.6707 77.9662 51.7609 77.992 51.8466 78.0176L51.8776 77.9638C51.8148 77.8988 51.7483 77.8318 51.6783 77.7626C51.6082 77.6935 51.5456 77.6239 51.4905 77.5538L50.4816 76.1467L50.9752 75.2916ZM52.2971 77.6968L53.975 78.6656L53.4999 79.4884L51.822 78.5197L52.2971 77.6968Z",
    fill: "url(#paint16_radial_878_36086)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3645 71.1534C53.4762 70.9598 53.6346 70.9173 53.8395 71.0261L57.3298 72.8548L56.892 73.6131L53.7444 71.9607L53.6886 72.0575L55.6564 73.9896C55.8099 74.1212 55.8338 74.2785 55.7283 74.4613L55.4302 74.9776C55.3246 75.1605 55.1744 75.2219 54.9795 75.162L52.3224 74.4238L52.2696 74.5152L55.2806 76.4042L54.8397 77.1679L51.5108 75.0595C51.3142 74.9364 51.2728 74.7763 51.3866 74.5791L51.8306 73.8101C51.9321 73.6344 52.082 73.5775 52.2804 73.6395L54.4229 74.2383C54.5214 74.2665 54.6196 74.2993 54.7175 74.3367C54.8118 74.372 54.909 74.4066 55.0089 74.4404L55.0493 74.3705C54.97 74.3008 54.8915 74.234 54.8137 74.17C54.7344 74.1003 54.6552 74.0306 54.5759 73.9609L52.9884 72.4134C52.8334 72.2761 52.8076 72.1178 52.9111 71.9385L53.3645 71.1534Z",
    fill: "url(#paint17_radial_878_36086)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7842 68.5453C54.8856 68.3696 54.9769 68.2239 55.058 68.1082C55.1377 67.9869 55.2165 67.8794 55.2944 67.7858C55.3724 67.6921 55.4596 67.5991 55.556 67.5066L56.1211 67.9189C56.0456 68.033 55.9771 68.1393 55.9155 68.2376C55.8561 68.3323 55.7932 68.4371 55.727 68.5518C55.6592 68.6609 55.5798 68.7943 55.4887 68.952C55.3831 69.1349 55.3362 69.299 55.3479 69.4443C55.3616 69.5861 55.4457 69.7303 55.6001 69.8768C55.751 70.0213 55.9823 70.1835 56.2943 70.3636C56.6062 70.5437 56.8642 70.664 57.0683 70.7245C57.2688 70.7829 57.4339 70.7826 57.5636 70.7236C57.6953 70.661 57.814 70.5383 57.9195 70.3554C58.0623 70.1081 58.1788 69.898 58.2689 69.7254C58.3591 69.5528 58.4428 69.3788 58.5201 69.2035L59.1627 69.4814C59.1172 69.6845 59.0534 69.8819 58.9714 70.0736C58.893 70.2674 58.7772 70.4969 58.624 70.7622C58.4025 71.1458 58.1636 71.419 57.9071 71.5816C57.6492 71.7386 57.3503 71.7884 57.0107 71.7309C56.6731 71.6698 56.2676 71.5027 55.7944 71.2295C55.3211 70.9562 54.9736 70.6887 54.7519 70.4268C54.5323 70.1614 54.4278 69.8788 54.4384 69.5789C54.4474 69.2735 54.5627 68.9289 54.7842 68.5453Z",
    fill: "url(#paint18_radial_878_36086)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8604 65.0982C56.8997 65.0301 56.9536 64.9823 57.022 64.9549C57.0925 64.9239 57.1652 64.9181 57.2401 64.9374L61.3567 65.88L60.8723 66.719L57.7079 65.9031C57.6387 65.8822 57.5695 65.8614 57.5002 65.8405C57.4274 65.8176 57.3592 65.795 57.2957 65.7726L57.2118 65.9178C57.263 65.9617 57.3167 66.0094 57.3729 66.061C57.4277 66.107 57.4804 66.1565 57.531 66.2096L59.8198 68.5421L59.3323 69.3864L56.4607 66.2873C56.4066 66.2321 56.3742 66.168 56.3638 66.095C56.3554 66.0185 56.3709 65.9462 56.4102 65.878L56.8604 65.0982ZM59.303 65.7484L59.9215 66.1055L58.8099 68.0308L58.1915 67.6737L59.303 65.7484Z",
    fill: "url(#paint19_radial_878_36086)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61839 50.262V58.17C6.61839 58.471 6.68526 58.6883 6.81901 58.8221C6.96391 58.9447 7.19798 59.006 7.52121 59.006H8.59121L8.85872 60.6779C8.65809 60.7447 8.41288 60.8005 8.12309 60.845C7.83329 60.9008 7.5435 60.9398 7.2537 60.9621C6.96391 60.9955 6.7187 61.0122 6.51807 61.0122C5.7713 61.0122 5.18614 60.8116 4.76259 60.4104C4.35019 60.0091 4.14399 59.4462 4.14399 58.7217L4.12728 50.262H6.61839ZM8.92559 52.5525V54.1742H2.68945V52.6361L4.29446 52.5525H8.92559Z",
    fill: "url(#paint20_linear_878_36086)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8331 52.3351C17.3935 52.3351 18.1737 53.0986 18.1737 54.6256V60.8116H15.6826V55.3947C15.6826 55.0269 15.6158 54.7761 15.482 54.6423C15.3594 54.4974 15.1365 54.425 14.8132 54.425C14.4566 54.425 14.0888 54.4919 13.7098 54.6256C13.3308 54.7594 12.8627 54.9767 12.3054 55.2777L12.0881 53.9903C12.7011 53.4553 13.3253 53.0485 13.9606 52.7698C14.5959 52.48 15.2201 52.3351 15.8331 52.3351ZM12.5562 49.1084L12.5729 51.9673C12.5729 52.402 12.5451 52.8144 12.4893 53.2045C12.4447 53.5946 12.389 53.9234 12.3221 54.1909L12.5562 54.4083V60.8116H10.0818V49.1084H12.5562Z",
    fill: "url(#paint21_linear_878_36086)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M23.868 52.3351C25.2612 52.3351 26.2587 52.5748 26.8606 53.0541C27.4737 53.5222 27.7802 54.2244 27.7802 55.1606C27.7913 55.9186 27.6018 56.487 27.2117 56.866C26.8216 57.2338 26.1473 57.4177 25.1887 57.4177H20.5743V56.03H24.5033C24.8822 56.03 25.1219 55.952 25.2222 55.7959C25.3336 55.6288 25.3894 55.4003 25.3894 55.1105C25.3782 54.7204 25.2612 54.4529 25.0383 54.308C24.8265 54.1519 24.4643 54.0739 23.9515 54.0739C23.4946 54.0739 23.1379 54.1352 22.8815 54.2578C22.6252 54.3804 22.4468 54.6145 22.3465 54.96C22.2462 55.3055 22.1961 55.8071 22.1961 56.4647C22.1961 57.1557 22.2574 57.6908 22.38 58.0697C22.5026 58.4375 22.7088 58.6939 22.9986 58.8388C23.2995 58.9837 23.7119 59.0561 24.2358 59.0561C24.6147 59.0561 25.0829 59.045 25.6402 59.0227C26.2086 58.9893 26.777 58.9391 27.3455 58.8722L27.5795 60.3936C27.2563 60.5497 26.8885 60.6723 26.4761 60.7615C26.0637 60.8506 25.6402 60.9119 25.2055 60.9454C24.7708 60.9899 24.3528 61.0122 23.9515 61.0122C22.9038 61.0122 22.0567 60.8618 21.4103 60.5608C20.775 60.2487 20.3124 59.775 20.0226 59.1397C19.744 58.5044 19.6046 57.6908 19.6046 56.6988C19.6046 55.6176 19.7495 54.7594 20.0393 54.1241C20.3291 53.4887 20.7861 53.0318 21.4103 52.7531C22.0344 52.4745 22.8537 52.3351 23.868 52.3351Z",
    fill: "url(#paint22_linear_878_36086)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5134 21.2236C49.8207 21.2198 48.4462 22.5889 48.4425 24.2824C48.4413 24.8101 48.5553 25.3045 48.8037 25.7368L60.2398 45.6572C60.7653 46.5746 61.7566 47.1957 62.8931 47.1982C64.0296 47.2007 65.0188 46.584 65.5483 45.6689L77.0771 25.7992C77.3274 25.368 77.4436 24.8741 77.4447 24.3464C77.4485 22.6529 76.08 21.2778 74.3873 21.2741L51.5134 21.2236V21.2236Z",
    fill: "url(#paint23_radial_878_36086)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6966 49.3845L38.6966 49.3797C38.6966 49.3797 38.6966 49.3797 38.6966 49.3845ZM26.6004 21.1721C25.3015 21.1692 24.2437 22.2246 24.2409 23.5265C24.24 23.9333 24.3299 24.3212 24.5202 24.647L38.6966 49.3845C39.3437 50.4963 39.7133 51.7894 39.7102 53.1726C39.7072 54.5558 39.3511 55.7659 38.7327 56.851L26.3167 78.3087C26.1297 78.6338 26.0333 79.0212 26.0324 79.428C26.0296 80.7299 27.0826 81.7899 28.3863 81.7928L40.349 81.8192C42.9039 81.8249 45.2038 80.5425 46.407 78.4631L46.6563 78.0329L58.6025 57.4022L58.823 57.0198C59.4318 55.9682 59.7162 54.7627 59.7191 53.48C59.7219 52.1973 59.3809 50.8852 58.7673 49.8069L58.6436 49.5913L44.5527 25.0072L44.3054 24.5759C43.1113 22.4912 40.8123 21.1987 38.2622 21.1931L26.6004 21.1673L26.6004 21.1721Z",
    fill: "url(#paint24_linear_878_36086)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_878_36086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(109.592 34.129) scale(11.011)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EC2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#00AE9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008C76"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_878_36086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(132.75 34.0663) scale(13.6836 11.3306)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EC2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#00AE9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008C76"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_878_36086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(156.827 33.9533) scale(14.1904 10.7577)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EC2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#00AE9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008C76"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_878_36086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(178.86 34.129) scale(11.011)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EC2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#00AE9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008C76"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_878_36086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(202.249 34.034) scale(12.2758 10.6944)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EC2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#00AE9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008C76"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_878_36086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(111.075 66.6414) scale(15.2343 11.5507)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EC2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#00AE9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008C76"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_878_36086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(135.851 66.7112) scale(11.8773 11.4783)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EC2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#00AE9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008C76"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_878_36086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(159.757 66.7112) scale(11.8773 11.4783)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EC2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#00AE9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008C76"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_878_36086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(184.335 66.7147) scale(12.7177 11.4813)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EC2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#00AE9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008C76"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_878_36086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(209.632 66.7572) scale(14.6929 12.1688)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EC2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#00AE9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008C76"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_878_36086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(235.481 66.6414) scale(15.243 11.5507)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EC2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#00AE9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008C76"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_878_36086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(259.144 66.8378) scale(11.8297 11.8281)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EC2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#00AE9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008C76"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_878_36086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(284.265 66.7147) scale(13.1855 11.4813)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EC2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#00AE9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008C76"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_878_36086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(257.618 33.9886) scale(12.495)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCAF17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FBAB17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F9A119"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#F78F1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F47920"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F07321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#E56524"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#DD5928"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_878_36086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(285.28 21.2487) scale(12.495 12.495)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCAF17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FBAB17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F9A119"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#F78F1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F47920"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F07321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#E56524"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#DD5928"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_878_36086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(229.944 33.9886) scale(12.495)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCAF17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FBAB17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F9A119"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#F78F1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F47920"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F07321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#E56524"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#DD5928"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_878_36086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.2174 72.2153) scale(7.59803 6.27224)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EC2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#00AE9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008C76"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_878_36086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.2174 72.2153) scale(7.59803 6.27224)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EC2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#00AE9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008C76"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_878_36086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.2174 72.2153) scale(7.59803 6.27224)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EC2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#00AE9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008C76"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_878_36086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.2174 72.2153) scale(7.59803 6.27224)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EC2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#00AE9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008C76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_878_36086",
    x1: 4.18735,
    y1: 48.9005,
    x2: 5.09273,
    y2: 61.7281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAC18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F37621"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_878_36086",
    x1: 4.18735,
    y1: 48.9005,
    x2: 5.09273,
    y2: 61.7281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAC18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F37621"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_878_36086",
    x1: 4.18735,
    y1: 48.9005,
    x2: 5.09273,
    y2: 61.7281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAC18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F37621"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_878_36086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.9217 34.2377) rotate(0.126492) scale(17.9468 11.177)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EC2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#00AE9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008C76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_878_36086",
    x1: 26.3704,
    y1: 20.108,
    x2: 41.8843,
    y2: 81.8226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAC18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F37621"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYmcaTcaLogo);
export default __webpack_public_path__ + "static/media/ymca-tca-logo.2025fcd2925c613165bcf09d081cb90c.svg";
export { ForwardRef as ReactComponent };